import { DsSelect, DsSelectItem } from '@frontends/ds';
import { DsIcon } from '@frontends/ds-icons';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { CountryData } from '@/types/Country';

const CountrySelect = memo(function CountrySelect({
  label,
  countries,
  isLoading,
  isDisabled,
  value,
  onChange,
  isInvalid,
  errorMessage,
}: {
  label: string;
  countries: CountryData[];
  isLoading: boolean;
  isDisabled?: boolean;
  value: string;
  onChange: (value: string) => void;
  isInvalid?: boolean;
  errorMessage?: string;
}) {
  const { t } = useTranslation();

  return (
    <DsSelect
      isFullWidth
      label={label}
      placeholder={t('select_country')}
      items={isLoading ? [] : countries}
      isDisabled={isDisabled}
      value={value || null}
      onChange={(key) => onChange(key === null ? '' : String(key))}
      validationBehavior="aria"
      isInvalid={isInvalid}
      errorMessage={errorMessage}
      renderEmptyState={isLoading ? () => <DsIcon name="loader" size="md" className="animate-spin" /> : undefined}
    >
      {(country) => <DsSelectItem id={String(country.country_code)}>{country.name ?? country.iso_3166_2}</DsSelectItem>}
    </DsSelect>
  );
});

export default CountrySelect;
